import React from "react";
import {SvgIcon, SvgIconProps} from "@mui/material";

const SplitVerticalIconSvg = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M3.5 12V17.5C3.5 18.6046 4.39543 19.5 5.5 19.5H12H18.5C19.6046 19.5 20.5 18.6046 20.5 17.5V12M3.5 12V6.5C3.5 5.39543 4.39543 4.5 5.5 4.5H12H18.5C19.6046 4.5 20.5 5.39543 20.5 6.5V12M3.5 12H9.5M20.5 12H14.5"
            stroke="currentColor" strokeWidth="0.85" strokeLinecap="round"/>
        <path d="M12 16.5V7.5M12 16.5L10.5 15M12 16.5L13.5 15M12 7.5C12 7.5 11.0858 8.41421 10.5 9M12 7.5L13.5 9" stroke="currentColor" strokeWidth="0.85" strokeLinecap="round"/>
    </svg>

)

const SplitVerticalIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {SplitVerticalIconSvg}
    </SvgIcon>
);

export default SplitVerticalIcon